import PesananService from '@/services/pesanan'
import ProductsService from '@/services/products'
import JadwalService from '@/services/jadwal'
// import UsersService from '@/services/users'
import AuthService from '@/services/auth'
import { forEach, find } from "lodash"
import dayjs from "dayjs";

export default {
	namespaced: true,
	state: {
		listPesanan: [],
		listProduct: [],
		totalHargaPesanan: 0,
		numberOfList: 0,
		submissionForCompany: false
		// customerData: {
		// 	id: 0,
		// 	name: null,
		// 	email: null,
		// 	telp: null
		// },
		// userFound: false,
		// newUser: false,
		// haveCompany: false
	},

	getters: {
		async getItems({ commit, state, getters, dispatch }) {
			try {
				let response = await ProductsService.getItems()
				return response
			} catch (e) {
				console.log(e)
			}
		}
	},

	actions: {
		async getProducts({ commit, state, getters, dispatch }, product_category_id) {
			try {
				const category = await AuthService.getCategoryId()
				window.localStorage.setItem('category', JSON.stringify(category.data[0]));

				let opts = {
					'interfaces': ['pos'],
					// 'type': ['MANAGED_STOCK'],
					'product_category_id': product_category_id
				}
				
				let response = await ProductsService.getProducts(opts)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getProductCategory({ commit, state, getters, dispatch }, type) {
			try {
				let companyId = JSON.parse(window.localStorage.getItem('company')).id
				let opts = {
					'interfaces': ['pos'],
					'type': type,
					'company_id': companyId
				}
				let response = await ProductsService.getProductCategory(opts)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async createProducts({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await ProductsService.createProducts({
					...payload
				});
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async updateProducts({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await ProductsService.updateProducts(payload.id, {
					...payload
				})
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async deleteProducts({ commit, state, getters, dispatch }, id) {
			let response
			try {
				response = await ProductsService.deleteProducts(id);
			} catch (e) {
				console.log(e);
			}
			return response
		},
		calculateTotal({ commit, state, getters, dispatch }){
            let total = 0
            forEach(state.listPesanan, list =>{
                const subtotal = Number(list.harga_jual) * (1-(Number(list.discount) / 100)) * Number(list.qty)
                total += subtotal
			})
			commit('SET_LIST_PESANAN', state.listPesanan)
            commit('SET_TOTAL_HARGA_PESANAN', total)
        },
		resetPesanan({ commit, state, getters, dispatch }){
            commit('SET_LIST_PESANAN', [])
            commit('SET_TOTAL_HARGA_PESANAN', 0)
        },
		async checkoutPesanan({ commit, state, getters, dispatch }, partner){
			let due_date
			forEach(state.listPesanan, list => {
				if(list.selesai != undefined){
					due_date = list.selesai
				}else{
					due_date = dayjs().format('YYYY-MM-DD HH:mm:ss')
				}
			})
			const payload = {
				name: partner.name + ' ' + new Date().getTime() + ' pos',
				type: 'PEMASUKAN',
				total: state.totalHargaPesanan,
				status: 'APPROVED',
				category_id: JSON.parse(window.localStorage.getItem('category')).id,
				partner_id: partner.id,
				items: state.listPesanan,
				date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
				due_date: due_date,
				submission_for_company: state.submissionForCompany
			}
			
			const response = await PesananService.createPesanan(payload)
			return response
		},
		async updateItem({ commit, state, getters, dispatch }, payload) {
			try {
				let response = await ProductsService.updateItems(payload.id, {...payload})
				return response
			} catch (e) {
				console.log(e)
			}
		},
		// async searchUser(){
		// 	commit('SET_USER_FOUND', false)
		// 	commit('SET_NEW_USER', false)
		// 	commit('SET_HAVE_COMPANY', false)
		// 	// this.userFound = false
		// 	// this.newUser = false
		// 	// this.haveCompany = false
		// 	const response = await UsersService.getUsersByEmailOrPhone(this.inputSearch)
		// 	if(response.data != ""){
		// 		if(response.data.company_id != 0){
		// 			commit('SET_HAVE_COMPANY', true)
		// 		}else{
		// 			if(userHaveRoles(['super_admin'])){
		// 				if(response.data.roles[0].name == "entity" || response.data.roles[0].name == "verified"){
		// 					commit('SET_HAVE_COMPANY', true)
		// 				}else{
		// 					const customerData = {
		// 						id: response.data.id,
		// 						name: response.data.name,
		// 						email: response.data.email,
		// 						telp: response.data.telp
		// 					}

		// 					commit('SET_CUSTOMER_DATA', customerData)
		// 					commit('SET_USER_FOUND', true)
		// 				}
		// 			}else{
		// 				if(response.data.roles[0].name == "entity"){
		// 					commit('SET_HAVE_COMPANY', true)
		// 				}else{
		// 					const customerData = {
		// 						id: response.data.id,
		// 						name: response.data.name,
		// 						email: response.data.email,
		// 						telp: response.data.telp
		// 					}

		// 					commit('SET_CUSTOMER_DATA', customerData)
		// 					commit('SET_USER_FOUND', true)
		// 				}
		// 			}
		// 		}
		// 	}else{
		// 		const customerData = {
		// 			id: 0,
		// 			name: null,
		// 			email: null,
		// 			telp: null
		// 		}

		// 		commit('SET_CUSTOMER_DATA', customerData)
		// 		commit('SET_NEW_USER', true)
		// 	}
		// }
	},

	mutations: {
		SET_LIST_PESANAN(state, payload) {
			// console.log('payload', payload)
			state.listPesanan = payload;
			window.localStorage.setItem('listPesanan', JSON.stringify(payload));
			window.localStorage.setItem('numberOfList', payload.length);
			state.numberOfList = payload.length;
		},
		SET_LIST_PRODUCT(state, payload) {
			state.listProduct = payload;
		},
		SET_TOTAL_HARGA_PESANAN(state, payload) {
			state.totalHargaPesanan = Number(payload);
		},
		SET_SUBMISSION_FOR_COMPANY(state, payload) {
			state.submissionForCompany = payload;
		},
		// SET_CUSTOMER_DATA(state, payload) {
		// 	state.customerData = Object.assign({}, payload);
		// },
		// SET_USER_FOUND(state, payload){
		// 	state.userFound = payload;
		// },
		// SET_HAVE_COMPANY(state, payload){
		// 	state.haveCompany = payload;
		// },
		// SET_NEW_USER(state, payload){
		// 	state.newUser = payload;
		// }
	}
};
